import React, { } from "react";
import BrandComponents from "../../Masters/Brand/BrandComponents";

function ProductionOrderTable() {

  let header = [
    { label: "Id", field: "id" },
    { label: "PO Number", field: "productionordernumber" },
    { label: "Part Number", field: "partno" },
    { label: "Job Number", field: "jobnumber" },
    { label: "Customer Name", field: "customername" },
    { label: "Date", field: "podate" },
    { label: "Action", field: "action" },
  ];

  return (
    <div>
      <BrandComponents
        header={header}
        tableTitle={"PRODUCTION ORDER LIST"}
        apiField={"productionorder"}
        addButton={"+ ADD"}
        createRoute={"/PorderCreate"}
        updateRoute={"/PorderView"}
        viewRoute={"/PorderView"}
      />
    </div>
  );
}

export default ProductionOrderTable;
